import React from 'react';
import StatsBarItem from './StatsBarItem';

const StatsBar = () => {
  return (
    <>
      <div className="flex flex-col flex-grow px-5 py-3 text-gray-100 rounded-lg bg-jcap-900">
        <div className="grid grid-flow-col col-gap-5">
          <StatsBarItem
            label="Total Position as GBP"
            value="£507,030,274"
            delta={2}
          />
          <StatsBarItem
            label="Annualised Interest"
            value="£830,200"
            delta={-2}
          />
          <StatsBarItem label="Weekly Change" value="£21,000" />
        </div>
      </div>
      <div className="flex justify-start mt-2 text-xs text-gray-700 opacity-50 cursor-default select-none">
        <p>Updated December 11 2020, 8:00 GMT</p>
      </div>
    </>
  );
};

export default StatsBar;
